//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('accountingAllocation', {
//        templateUrl: 'views/components/views/accountingAllocation/accountingAllocation.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'translateService', 'modalService', 'accountingAllocationService', 'logisticService', 'ttGridFactory', function ($stateParams, stateService, translateService, modalService, accountingAllocationService, logisticService, ttGridFactory) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let accountingAllocationKeyno = $stateParams.accountingallocation_keyno;

//            let translations = {
//                confirm_title: '',
//                confirm_message: '',
//                confirm_ok_label: '',
//                confirm_cancel_label: '',
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                accountingAllocationKeyno: accountingAllocationKeyno,
//                gridReady: false,
//                edit: {},
//                selectListCompanies: [],
//                lockedSave: false,
//                lockedDelete: false
//            };

//            vm.grid = new ttGridFactory({
//                rememberId: 'accountingallocationline_grid',
//                kendo: {
//                    height: '100%',
//                    sortable: true,
//                    aggregate: true,
//                    pager: false,
//                    selectable: false,
//                    filterable: false
//                }
//            }).setCustomToolbarButtons([{
//                name: 'accountingallocation_new',
//                text: 'accountingallocation_new',
//                func: () => {
//                    stateService.go('accountingallocationline', {
//                        accountingallocation_keyno: vm.model.edit.accountingallocation_keyno,
//                    	accountingallocationline_keyno: '0'
//                    });
//                },
//                icon: 'fa-plus',
//                cssClass: 'btn btn-primary im-grid-btn-xs-r',
//                translate: true
//            }]);
            
//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATE SERVICE

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATE SERVICE

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadEdit() {
//                vm.model.edit = (await accountingAllocationService.getEdit({ accountingallocation_keyno: accountingAllocationKeyno }))[0];

//                return loadGrid();
//            }

//            async function loadCompanies() {
//                vm.model.selectListCompanies = await logisticService.listCompanies();
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region GRID PROCEDURE FUNCTION CALLS

//            async function loadGrid() {
//                vm.grid.dataTask.loadData = {
//                    method: 3773,
//                    parameters: vm.model.edit
//                };

//                vm.model.gridReady = true;

//                if (vm.grid.gridfunc !== null) vm.grid.gridfunc.read();
//            }

//            // #endregion GRID PROCEDURE FUNCTION CALLS

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                accountingAllocationService.saveObj(vm.model.edit).then((response) => {
//                    if (response[0] && response[0].errorcode !== '0') {
//                    	modalService.show({
//                    		type: 'warning',
//                    		title: translations.error,
//                    		message: response[0].errormessage,
//                    		buttons: [{
//                    			label: translations.ok,
//                    			cssClass: 'btn-warning',
//                    			action: (dialogItself) => {
//                    				dialogItself.close();
//                    				vm.model.lockedSave = false;
//                    			}
//                    		}]
//                    	});
//                    } else {
//                    	vm.model.lockedSave = false;
//                    	stateService.back();
//                    }
//                });
//            };

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region BUTTON DELETE PROCEDURE FUNCTION CALL

//            vm.deleteValues = function () {
//                vm.model.lockedDelete = true;

//                modalService.confirm({
//                    type: 'danger',
//                    title: translations.confirm_title,
//                    message: translations.confirm_message,
//                    okLabel: translations.confirm_ok_label,
//                    cancelLabel: translations.confirm_cancel_label
//                }).then(() => {
//                    accountingAllocationService.deleteItem(vm.model.edit).then((response) => {
//                        if (response[0] && response[0].errorcode !== '0') {
//                        	modalService.show({
//                        		type: 'warning',
//                        		title: translations.error,
//                        		message: response[0].errormessage,
//                        		buttons: [{
//                        			label: translations.ok,
//                        			cssClass: 'btn-warning',
//                        			action: (dialogItself) => {
//                        				dialogItself.close();
//                        				vm.model.lockedDelete = false;
//                        			}
//                        		}]
//                        	});
//                        } else {
//                        	vm.model.lockedDelete = false;
//                        	stateService.back();
//                        }
//                    }, () => {
//                        vm.model.lockedDelete = false;
//                    });
//                }, () => {
//                    vm.model.lockedDelete = false;
//                });
//            };

//            // #endregion BUTTON DELETE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                translate();
//            	loadEdit();
//                loadCompanies();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
